import { useState } from 'react';

import { Box, BoxProps, Typography, TypographyStyle } from '@mui/material';

export type Tab = {
    header: string;
    children: React.ReactElement;
};

interface TabSelectCard {
    tabs: Tab[];
    headerStyles?: TypographyStyle;
    headerContainerProps?: BoxProps;
    containerProps?: BoxProps;
    childrenContainerProps?: BoxProps;
}

export const TabSelectCard: React.FC<TabSelectCard> = ({
    tabs,
    headerStyles,
    headerContainerProps,
    containerProps,
    childrenContainerProps,
}) => {
    const [selectedTab, setSelectedTab] = useState<number>(0);

    const boxShadow = 'inset 0px 5px 15px rgba(0, 0, 0, 0.1)';

    return (
        <Box
            borderRadius="24px"
            width="100%"
            border="1px solid #F18F34"
            overflow="hidden"
            bgcolor="white"
            {...containerProps}
        >
            <Box display="flex" width="100%">
                {tabs.map(({ header }, index) => {
                    const isSelected = index === selectedTab;
                    return (
                        <Box
                            key={header}
                            onClick={() => {
                                setSelectedTab(index);
                            }}
                            bgcolor={isSelected ? '#F18F34' : 'white'}
                            color={isSelected ? 'white' : '#686867'}
                            boxShadow={isSelected ? boxShadow : undefined}
                            sx={{
                                cursor: 'pointer',
                                ':hover': {
                                    color: 'white',
                                    bgcolor: 'rgba(241, 143, 52, 0.9)',
                                    boxShadow,
                                },
                            }}
                            borderBottom="1px solid #F18F34"
                            width={`${(100 / tabs.length) * 100}%`}
                            {...headerContainerProps}
                        >
                            <Typography
                                fontSize="20px"
                                fontWeight="400"
                                lineHeight="28px"
                                textAlign="center"
                                textOverflow="ellipsis"
                                marginY="24px"
                                color="inherit"
                                style={headerStyles}
                            >
                                {header}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
            <Box padding="24px" {...childrenContainerProps}>
                {tabs[selectedTab].children}
            </Box>
        </Box>
    );
};
